// extracted by mini-css-extract-plugin
export default {"editPencilIcon":"RelatedTaskDisplay_editPencilIcon__Q6c1r"};